/* eslint-disable jsx-a11y/no-static-element-interactions */
import type { Channel } from '@entities/channel'
import { useChannels } from '@entities/channel'
import SearchPopup from '@entities/channel/ui/search-popup'
import { classNames } from '@shared/lib/classNames'
import { formatUrl } from '@shared/lib/formatUrl/formatUrl'
import { Avatar, Flex, Space, theme, Typography } from 'antd'
import { Dropdown } from 'antd-mobile'
import type { ReactNode } from 'react'
import { useCallback, useState } from 'react'
import { ChevronDown } from 'react-feather'
import { useNavigate } from 'react-router'
import * as styles from './mobile-header.module.scss'

const { Text } = Typography

interface Page {
    name: string
    url: string
    title: ReactNode
}

interface MobileHeaderProps {
    title: string
    titleIcon?: ReactNode
    current?: string
    pages?: Page[]
    filter?: ReactNode
    dropdownKey?: string
}

export const MobileHeader = ({ title, titleIcon, current, pages, filter, dropdownKey }: MobileHeaderProps) => {
    const {
        token: { colorPrimary }
    } = theme.useToken()

    const {
        channels,
        currentChannel,
        actions: { setCurrentChannel }
    } = useChannels()

    const [selectChannelPopup, setSelectChannelPopup] = useState(false)
    const [selectedChannelId, setSelectedChannelId] = useState<Nullable<number>>(null)

    const onCloseSelectChannelPopup = useCallback(() => setSelectChannelPopup(false), [])

    const onChange = (id: number) => {
        setCurrentChannel(channels?.find((c) => c.id === id) ?? null)
    }

    const navigate = useNavigate()

    return (
        <>
            <Flex justify="space-between" align="center" style={{ backgroundColor: 'white', paddingLeft: '16px' }}>
                <Avatar
                    size={40}
                    src={formatUrl(currentChannel?.photoUrl)}
                    onClick={(e) => {
                        e?.stopPropagation()
                        setSelectChannelPopup(true)
                    }}
                />

                <Dropdown>
                    <Dropdown.Item
                        arrowIcon={null}
                        title={
                            <Space style={{ height: '62px' }}>
                                {titleIcon}
                                <Text style={{ fontSize: 24, fontWeight: 500 }}>{title}</Text>
                                {pages?.length && <ChevronDown style={{ verticalAlign: 'middle' }} />}
                            </Space>
                        }
                        key={dropdownKey || ''}
                    >
                        {pages?.map((p) => (
                            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                            <div
                                className={classNames(styles.dropdownItem, {
                                    [styles.active]: current === p.name
                                })}
                                onClick={() => navigate(p.url)}
                                key={p.url}
                            >
                                {p.title}
                            </div>
                        ))}
                    </Dropdown.Item>
                </Dropdown>

                <div style={{ height: '62px', display: 'flex', alignItems: 'center' }}>{filter}</div>
            </Flex>
            {channels && (
                <SearchPopup
                    onSelect={(selectedChannelId) => setSelectedChannelId(+selectedChannelId)}
                    visible={selectChannelPopup}
                    onClose={onCloseSelectChannelPopup}
                    onClick={() => {
                        if (selectedChannelId) {
                            onChange(selectedChannelId)
                        }

                        onCloseSelectChannelPopup()
                    }}
                    title="Выбор канала"
                    name="channel"
                    avatar
                    data={channels.map((item: Channel) => ({
                        value: item.id,
                        label: item.name,
                        avatarUrl: formatUrl(item.photoUrl)
                    }))}
                />
            )}
        </>
    )
}
